import { useTranslation } from "react-i18next";
import BackButton from "../../../components/button/BackButton";
import Loader from "../../../components/loader";
import { useState } from "react";
import { PAGE_SIZE, TABLE_IDS } from "../../../constants/common";
import SearchPermitTable from "../../../components/table/SearchPermitTable";
import SearchPermitRequestCard from "../../../components/card/SearchPermitRequestCard";

const ApprovePermitRequest = () => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allPermits, setAllPermits] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <div className="flex items-center gap-1 sm:gap-2 justify-between">
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("approvePermitRequest")}
        </h1>

        <BackButton />
      </div>

      <SearchPermitRequestCard
        setIsLoading={setIsLoading}
        page={page}
        setPages={setPages}
        search={search}
        setCount={setCount}
        setAllPermits={setAllPermits}
        pageSize={pageSize}
      />

      {isLoading && (
        <div className="flex justify-center">
          <Loader />
        </div>
      )}

      <SearchPermitTable
        allPermits={allPermits}
        page={page}
        pages={pages}
        setPage={setPage}
        count={count}
        search={search}
        setSearch={setSearch}
        tableId={TABLE_IDS.APPROVE_PERMIT_REQUEST}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default ApprovePermitRequest;
